import { type ComponentPropsWithoutRef } from "react";
import { twMerge } from "tailwind-merge";

const PlusIcon = ({ className, ...props }: ComponentPropsWithoutRef<"svg">) => {
  const defaultClassnames = "h-3 w-3";

  return (
    <svg
      className={twMerge(defaultClassnames, className)}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      {...props}
    >
      <g id="Frame">
        <path
          id="Vector"
          d="M5 2.5V7.5M7.5 5H2.5"
          strokeWidth="0.625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default PlusIcon;
